(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind service
 * @name scBlocksService
 *
 * @description
 * Stores an object full o' blocks
 */
angular.module('classy').service('scBlocksService', ['scBlockModel', 'scAuthorizeService', 'PERMISSIONS', scBlocksService]);

function scBlocksService(scBlockModel, scAuthorizeService, PERMISSIONS) {
  var _this = this;

  this.blocks = {};

  this.add = function (blockData) {
    this.blocks[blockData.id] = new scBlockModel(blockData);
  };

  this.remove = function (id) {
    delete this.blocks[id];
  };

  this.get = function (id) {
    return _.get(this, 'blocks.' + id, false);
  };

  this.getIdByType = function (type) {
    return Object.keys(_this.blocks).filter(function (id) {
      return _this.blocks[id].defaults.type === type;
    })[0] || undefined;
  };

  this.getBlockByType = function (type) {
    var id = _this.getIdByType(type);
    return id && _this.blocks[id];
  };

  this.diffAll = function () {
    var diffs = [];
    _.forEach(this.blocks, function (block) {
      var blockDiffs = block.mongoDiff();

      if (typeof blockDiffs !== 'undefined') {
        angular.forEach(blockDiffs, function (diff) {
          diffs.push({
            block: block.current.type,
            diff: diff
          });
        });
      }
    });

    return diffs;
  };

  this.customBlocksCount = function () {
    return Object.keys(_this.blocks).reduce(function (count, id) {
      return _this.blocks[id].current.type === 'custom' || _this.blocks[id].current.type === 'text' || _this.blocks[id].current.type === 'html' || _this.blocks[id].current.type === 'global-css' ? count + 1 : count;
    }, 0);
  };

  this.list = function () {
    return this.blocks;
  };

  this.getHasAccess = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(permissions) {
      var authorized;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return scAuthorizeService.isAuthorized(permissions);

            case 2:
              authorized = _context.sent;
              return _context.abrupt('return', authorized.every(function (perm) {
                return perm.result;
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.init = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(blocks) {
      var _this2 = this;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _.forEach(blocks, function (blockData) {
                _this2.add(blockData);
              });

              _context2.next = 3;
              return this.getHasAccess(PERMISSIONS.campaign.update_custom_code);

            case 3:
              this.hasBlockAccess = _context2.sent;

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Restrict custom block access to those with permissions
  this.checkBlockAccess = function (block) {
    var restrictedBlocks = ['html', 'global-css'];
    if (restrictedBlocks.includes(block.type)) {
      return this.hasBlockAccess;
    }
    return true;
  };
}
})();